import axios, { AxiosRequestConfig, AxiosInstance } from 'axios'
import { Message, MessageBox } from 'element-ui'
import { UserModule } from '@/store/modules/user'
import { OTHER_URL, headerCaState } from '@/config'

// 返回类型
declare global {
  namespace Ajax1 {
    interface Response<T = any> {
      data: T
      code: number
      success: boolean
      errorMsg: string | null
    }
  }
}

// 重写AxiosInstance
export interface CusxiosInstance extends AxiosInstance {
  <T = any>(config: AxiosRequestConfig): Promise<T>
  request<T = any> (config: AxiosRequestConfig): Promise<T>
  get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>
  delete<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>
  head<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>
  post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T>
  put<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T>
  patch<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T>
}

const service: CusxiosInstance = axios.create({
  baseURL: OTHER_URL,
  timeout: 5000,
  headers: {
    'X-Ca-Stage': headerCaState()
  }
})

// Request interceptors
service.interceptors.request.use(
  (config) => {
    if (UserModule.token) {
      config.headers.Authorization = UserModule.token
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

// Response interceptors
service.interceptors.response.use(
  (response) => {
    // Some example codes here:
    // code == 20000: success
    // code == 50001: invalid access token
    const res = response.data
    if (res.succ !== 1) {
      if (res.code === 401) {
        MessageBox.confirm(
          '登录已过期，请尝试重新登录',
          '退出登录',
          {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          UserModule.ResetToken()
          location.reload() // To prevent bugs from vue-router
        })
      } else {
        Message({
          message: res.errorMsg || 'Error',
          type: 'error',
          duration: 5 * 1000
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return response.data
    }
  },
  (error) => {
    if (error.message.includes('timeout')) {
      Message({
        message: '请求已超时，网络竟然开了小差~~',
        type: 'error',
        duration: 5 * 1000
      })
    } else {
      Message({
        message: '服务异常，祭天一个程序员便可解决',
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service
